import React, { Dispatch, SetStateAction } from 'react';
import {Form} from 'react-bootstrap';
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PaginationState } from "@tanstack/react-table";

import { useTranslationUtils } from '../../Utilities/TranslationUtils';

export interface PaginationProps {
    pagination: PaginationState,
    setPagination: Dispatch<SetStateAction<PaginationState>>,
    nextPage: () => void,
    hasNextPage: boolean,
    previousPage: () => void,
    hasPreviousPage: boolean,
}

export function Pagination({pagination, setPagination, nextPage, hasNextPage, previousPage, hasPreviousPage}: PaginationProps) {
    const {tp} = useTranslationUtils();

    return (
        <div className="d-flex justify-content-end align-items-center">
            <div className="me-3">
                <Form.Select
                    id="pageSize"
                    size="sm"
                    value={pagination.pageSize}
                    onChange={e => setPagination({...pagination, pageSize: Number(e.target.value)})}>
                    {[10, 20, 30, 40, 50].map(pageSize => (
                        <option key={pageSize}
                            value={pageSize}>
                            {tp("Pagination.ShowXRows", {x: pageSize})}
                        </option>))}
                </Form.Select>
            </div>
            <span className="align-items-center me-3">
                {tp("Pagination.PageX", {x: pagination.pageIndex + 1})}
            </span>
            <div className="pagination">
                <button onClick={() => previousPage()}
                    disabled={!hasPreviousPage}>
                    <FontAwesomeIcon icon={faAngleLeft} />
                </button>
                <button onClick={() => nextPage()}
                    disabled={!hasNextPage}>
                    <FontAwesomeIcon icon={faAngleRight} />
                </button>
            </div>
        </div>
    );
}
